import { createAsyncActionType } from './index';

export const SCORM_CATEGORIES_GET = createAsyncActionType(
  'scorm',
  'SCORM_CATEGORIES_GET'
);
export const SCORM_LIST_GET = createAsyncActionType('scorm', 'SCORM_LIST_GET');
export const SCORM_DETAILS_GET = createAsyncActionType(
  'scorm',
  'SCORM_DETAILS_GET'
);

export const SCORM_DETAILS_RESET = '@@scorm/SCORM_DETAILS_RESET';
